import "./product-list.css";
import { NavLink } from "react-router-dom";

import addDotsToPrice from "../price-format";

// component hiển thị tất cả sản phẩm tại trang danh sách sản phẩm
const ProductAll = (props) => {
  return (
    <div className="container">
      <div className="row">
        {props.productShow.length > 0 &&
          props.productShow.map((prod, index) => {
            return (
              <div key={index} className="col-6 col-md-4 col-lg-3 text-center">
                <NavLink className="NavLink" to={`/products/${prod._id}`}>
                  <img src={prod.img1} alt={prod.name} className="pl-imgUrl" />
                  <p className="text-primary pl-name">{prod.name}</p>
                  <p className="text-center mb-0">
                    <span className="text-muted me-1">Store:</span>
                    <span
                      className={
                        prod.count > 0 ? "text-primary" : "text-danger"
                      }
                    >
                      {prod.count > 0 ? prod.count : "Hết hàng"}
                    </span>
                  </p>
                  <p className="text-danger fw-bold pl-price">
                    {addDotsToPrice(prod.price)}
                  </p>
                </NavLink>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ProductAll;
